import { useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../../../store';
import { deleteAllProducts } from '../../../../store/products';

export const useClearCartButton = () => {
  const [isVisibleClearCart, setVisibleClearCart] =
    useState(false);
  const dispatch: AppDispatch = useDispatch();

  const onClickByClearCartButton = useCallback(() => {
    setVisibleClearCart(true);
  }, []);

  const onCloseClearCartModal = useCallback(() => {
    setVisibleClearCart(false);
  }, []);

  const onAcceptClearCart = useCallback(() => {
    dispatch(deleteAllProducts());

    setVisibleClearCart(false);
  }, [dispatch]);

  return {
    isVisibleClearCart,
    onClickByClearCartButton,
    onCloseClearCartModal,
    onAcceptClearCart
  };
};
